export enum EFlowEvent {
  FLOW_COMPLETE = 'FLOW_COMPLETE',
  FLOW_EXIT = 'FLOW_EXIT',
  FLOW_ERROR = 'FLOW_ERROR',
  FLOW_NAVIGATION_UPDATE = 'FLOW_NAVIGATION_UPDATE',
}
